import { ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST } from 'app-redux/actions/languages.actions';
import { LanguageModel } from 'core/languages/languages.model';
import { PayloadAction } from 'core/utils/actionUtils';

export interface LanguagesState {
  languages: LanguageModel[];
  loading: boolean;
  error: any;
}

const initialState: LanguagesState = {
  languages: [],
  loading: false,
  error: null,
};

export const LanguagesReducer = (state: LanguagesState = initialState, action: PayloadAction<any>): LanguagesState => {
  switch (action.type) {
    case ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST.REQUEST:
      return { ...state, loading: true, };
    case ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST.SUCCESS:
      return { ...state, languages: action.payload, loading: false, };
    case ACTION_GET_ALL_AVAILABLE_LANGUAGES_LIST.ERROR:
      return { ...state, loading: false, error: action.payload, };
    default:
      return state;
  }
};
